import type { MagicJumpItem } from '@/api/types/magic-jump';
import { useRoute } from 'vue-router';

/** 顶部导航埋点：跳转目标统一字符串（兼容 BFF 数字 ID） */
export function formatNavPitJumpContent(
  target: MagicJumpItem | null | undefined,
): string | undefined {
  const v = target?.Jump_target;
  if (v === undefined || v === null) {
    return undefined;
  }
  return String(v);
}

export function useLayoutSensors() {
  const route = useRoute();

  /**
   * @TrackType sensorsdata
   * @EventDesc 顶部导航tab浮层曝光
   */
  const trackTopNavBar_Exp = (first_level_index: number, first_level_nav: string) => {
    try {
      const sdEventName = 'TopNavBar_Exp';
      const sdEventParams = {
        page_name: route.meta?.cnName,
        url_path: window.location.href,
        first_level_index,
        first_level_nav,
      };
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  };
  /**
   * @TrackType sensorsdata
   * @EventDesc 顶部导航tab浮层tab点击
   */
  const trackTopNavBarTab_Click = (
    first_level_index: number,
    first_level_nav: string,
    second_level_index: number,
    second_level_nav: string,
    third_level_index: number,
    third_level_nav: string,
  ) => {
    try {
      const sdEventName = 'TopNavBarTab_Click';
      const sdEventParams = {
        page_name: route.meta?.cnName,
        url_path: window.location.href,
        first_level_index,
        first_level_nav,
        second_level_index,
        second_level_nav,
        third_level_index,
        third_level_nav,
      };
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  };
  /**
   * @TrackType sensorsdata
   * @EventDesc 顶部导航tab浮层坑位点击 (包括图片类型的二三级导航)
   */
  const trackTopNavBarMkt_Click = (
    first_level_index: number,
    first_level_nav: string,
    second_info: {
      second_level_index?: number;
      second_level_nav?: string;
      pits_index?: number;
      pits_jump_type?: number;
      pits_jump_content?: string | number;
      pits_title?: string;
    },
  ) => {
    try {
      const sdEventName = 'TopNavBarMkt_Click';
      const sdEventParams = {
        page_name: route.meta?.cnName,
        url_path: window.location.href,
        first_level_index,
        first_level_nav,
        second_level_index: second_info?.second_level_index,
        second_level_nav: second_info?.second_level_nav,
        pits_index: second_info?.pits_index,
        pits_jump_type: second_info?.pits_jump_type,
        pits_jump_content: second_info?.pits_jump_content,
        pits_title: second_info?.pits_title,
      };
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  };

  return {
    trackTopNavBar_Exp,
    trackTopNavBarTab_Click,
    trackTopNavBarMkt_Click,
  };
}
